/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/guid.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    import IMaintenanceFormCustomButton = Meevo.Components.Controls.IMaintenanceFormCustomButton;

    export class ScheduleLocationContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public showHeaderSchedule: boolean = true;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: ng.IQService,
                    protected $http: angular.IHttpService,
                    protected controller: Meevo.Plugins.MarketPricing.MarketPricingController,
                    protected contextService: IContextService,
                    protected scheduleLocationService: Meevo.Plugins.MarketPricing.ScheduleLocationService
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = this.appSettings.API_ENDPOINTS.marketPricing;

            this.sectionTemplatePath = "app/plugins/marketPricing/scheduleLocation/";

            this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_MARKETPRICING);
            this.entityType = 'marketPricing';

            this.initializeSections();
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsBaseDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                appSettings: this.appSettings,
                isPrimarySection: true,
                handlesOwnCrud: false,
                baseEndpoint: this.appSettings.API_ENDPOINTS.marketPricing,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                identityService: this.identityService,
                noun: Meevo.Model.NounEnum.MarketPricing,
                $q: this.$q,
                busyService: this.busyService,
                $translate: this.$translate,
            };

            // TODO update security key
            // if (this.securityChecker.hasSecurity(this.securityKeys.MANAGEMENT_MARKETPRICING_ACTION_SCHEDULELOCATIONTRANSFER + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new SelectLocations(
                    _.extend({}, baseSectionProps, {
                        sectionId: 0,
                        displayNameContentKey: 'LABEL_SELECT_LOCATIONS',
                        template: 'selectLocations.html',
                        sectionEndpoint: 'LocationTransfer',
                        modalService: this.modalService
                    }), this.scheduleLocationService));
            // }

            // if (this.securityChecker.hasSecurity(this.securityKeys.MANAGEMENT_MARKETPRICING_ACTION_SCHEDULELOCATIONTRANSFER + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MembershipGrandfather(
                    _.extend({}, baseSectionProps, {
                        sectionId: 1,
                        displayNameContentKey: 'LABEL_MEMBERSHIP_GRANDFATHER_SETTINGS',
                        template: 'membershipGrandfather.html',
                        sectionEndpoint: 'LocationTransfer'
                    }), this.scheduleLocationService));
            // }
        }

        initializeHeader(model: any): void {
            this.headerContent = this.contextService.sharedData.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        /**
         * Deletes the selected item. Similar to DataMaintenance but need use Delete request.
         */
        delete(): void {
            let vm = this;
            if (this.canDelete) {
                this.modalService.confirm("MESSAGE_DELETE_CONFIRMATION_SCHEDULE_LOCATION_TRANSFER")
                    .then((response: boolean) => {
                        vm.loadingInProgress = true;
                        this.usageTrackingLog(Meevo.Model.VerbEnum.Deleted, null);

                        let uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/${this.selectedSection.model['priceGroupQueueId']}/${this.selectedSection.sectionEndpoint}`;

                        this.$http.delete(uri, {})
                            .then((data: any) => {
                                if (data) {
                                    vm.selectedSection.model = data;
                                    vm.selectSection(this.sections[0])
                                    //vm.selectedSection.sectionModelRetrieved();
                                }
                                vm.loggingService.trace(`Delete saved.`);
                                this.postDelete();
                            })
                            .finally(() => {
                                vm.loadingInProgress = false
                            });
                    });
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
        }

        save(): angular.IPromise<any> {
            if (this.selectedSection instanceof MembershipGrandfather) {
                this.itemId = this.selectedSection.model['priceGroupQueueId'];
            } else {
                this.itemId = this.selectedSection['parentItemId'];
            }
            
            return super.save();
        }

        public postCancel() {
            if (this.selectedSection instanceof SelectLocations) {
                this.selectedSection.postCancel();
            }
        }

        public backToDetails(redirectId: string = ''): void {
            if (this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            } else {
                if (redirectId !== '') {
                    this.modalService.confirmHandler('MESSAGE_EXIT_UNSAVED', Meevo.Components.Modal.ModalTranslationModes.Translate)
                        .then((response: boolean) => {
                            if (response === true) {
                                this.contextService.setVisualState(Model.MaintenanceFormVisualState.Detail);

                                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                                    stateName: this.appSettings.ROUTE_NAMES.marketPricing,
                                    stateParams: {
                                        actionState: Meevo.Model.MaintenanceFormState.Readonly,
                                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                                        id: redirectId
                                    }
                                });
                            }
                        });
                } else {
                    this.contextService.setVisualState(Model.MaintenanceFormVisualState.Detail);
                }
                
            }
        }

        selectSection(item) {
            if (this.selectedSection instanceof SelectLocations && !this.selectedSection.model && !this.selectedSection.model['locationsToTransfer']) { //&& !this.selectedSection.model && (!this.selectedSection.model['scheduleDate'] || !this.selectedSection.model['locationsToTransfer'])
                this.setMode(Model.MaintenanceFormState.Editing);
            }

            if (item.sectionId === 0 && this.selectedSection) {
                this.itemId = this.selectedSection.model['priceGroupId'];
            }

            super.selectSection(item);
        }
        public get canEdit(): boolean {
            return this.canEditDeleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted;

        }
        public get canEditDeleted(): boolean {
            return this.verifySelectedSectionModel() &&
                !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge;
        }
    }
}